import { Layout, Space, theme, Tooltip } from "antd";
import { CurrentUser } from "./CurrentUser";
import { MoonFilled, SunOutlined } from "@ant-design/icons";
import { useThemeMode } from "antd-style";
import { useTranslation } from "react-i18next";
import { RegionSelector } from "./RegionSelector";
import { ClosableTextComponent } from "./Message";
import { useAuthContext } from "@/providers/auth-provider";
import { useEffect, useState } from "react";
import { getInstances } from "@/apis";
import { RESOURCE_TYPE_INSTANCES } from "@/resources-def";
import { useList } from "@refinedev/core";
import { use } from "i18next";

export const Header = () => {
  const { token } = theme.useToken();
  const { themeMode, setThemeMode } = useThemeMode();
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const [hasInstance, setHasInstance] = useState(true);
  const {data: instanceList, loading} = useList({
    resource: RESOURCE_TYPE_INSTANCES,
  })

  const headerStyles = {
    backgroundColor: token.colorBgElevated,
    // display: "flex",
    // justifyContent: "flex-end",
    // alignItems: "center",
    // padding: "0px 24px",
    height: "64px",
    // position: "sticky",
    top: 0,
    zIndex: 1,
  };

  const switchMode = () => {
    if (themeMode === "light") {
      setThemeMode("dark");
    } else {
      setThemeMode("light");
    }
  };

  return (
    <Layout.Header style={{backgroundColor: "white", paddingLeft: '0px'}}>
    <div style={{ 
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '100%'
    }}>
      <div style={{ flex: 1, textAlign: 'center' }}>
        { !user?.isSaaSAdmin && user.tenant && use.tenant != "__root__" && (instanceList?.total == 0 || !instanceList?.data?.some(instance => instance.tenant == user.tenant)) && (<ClosableTextComponent text=""/>)}
      </div>

      <div style={{ marginLeft: 'auto' }}>
        <Space size='middle'>
        <RegionSelector />
        <Tooltip placement="bottom" title={t(`header.switchTheme.${themeMode}`)}>
          { themeMode === 'light' && <SunOutlined onClick={switchMode} /> }
          { themeMode === 'dark' && <MoonFilled onClick={switchMode} /> }
        </Tooltip>
        <CurrentUser />
      </Space>
      </div>
    </div>
      
    </Layout.Header>
  );
};